<template>
    <v-dialog
        v-model="display"
        width="500"
        persistent
        >
        <v-card>
            <v-card-title>{{title}}</v-card-title>
            <v-card-subtitle>{{ $t("JOBCARD_FAILURE_SUBTITLE") }}</v-card-subtitle>
            <v-card-text>
                <div v-if="loading.data" class="text-center">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-form
                    v-else
                    ref="form"
                    v-model="valid">
                    <v-text-field
                        :label="$t('JOBCARD_FAILURE_DESC')"
                        v-model="form.description"
                        :rules="rules.description"
                        @keypress.enter="submit"
                        ></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="submit" :disabled="!valid || loading.data || loading.submit" :loading="loading.submit">{{ $t("BTN_SAVE") }}</v-btn>
                <v-btn text @click="close">{{ $t("BTN_CANCEL") }}</v-btn>
            </v-card-actions>
        </v-card>
        <AlertDialog
            ref="alertDialog"/>
    </v-dialog>
</template>

<script>
import AlertDialog from '../components/AlertDialog';
import { mapState, mapActions } from 'vuex';
export default {
    name: "JobcardFailureDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            valid: false,
            editMode: false,
            id: null,
            form: {
                jobcard_id: null,
                description: null
            },
            rules: {
                description: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ]
            },
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed: {
        ...mapState("jobcardFailure", ["jobcardFailure"]),
        title() {
            if(!this.editMode) return this.$t("JOBCARD_FAILURE_NEW_TITLE");
            else return this.$t("JOBCARD_FAILURE_EDIT_TITLE");
        }
    },
    methods: {
        ...mapActions("jobcardFailure", ["fetchJobcardFailure", "fetchJobcardFailures", "storeJobcardFailure", "updateJobcardFailure"]),
        async open(params) {
            this.loading.data = true;
            this.editMode = params.editMode;
            this.display = true;
            this.form.jobcard_id = params.jobcard_id;
            if(this.editMode) {
                this.id = params.id;
                await this.fetchJobcardFailure(this.id);
                this.form = this.jobcardFailure;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeJobcardFailure(this.form)
                    .then(response => {
                        this.close();
                        this.fetchJobcardFailures(this.form.jobcard_id);
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    });
            } else {
                this.updateJobcardFailure({form: this.form, id: this.id})
                    .then(response => {
                        this.close();
                        this.fetchJobcardFailures(this.form.jobcard_id);
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    });
            }
        }
    }
}
</script>